import CustomModal from 'components/CustomModal';
import RangeProgressBar from 'components/RangeProgressBar';
import RangeSlider from 'components/RangeSlider';
import { toastMessageBox } from 'components/ToastifyMessage';
import IconButton from 'components/common/IconButton';
import ItemsLoading1 from 'components/itemsLoading/ItemsLoading1';
import SelectOption from 'components/select/SelectOption';
import { timeElapsed } from 'components/shared/shared';
import { getDrpAgents, getDrpAssetCategories } from 'functions/dropdowns';
import { agentFeedbackInertUpdate, getAgentFeedbacks, getTicketMasterCon, getUpdatesByTicket, ticketAssign } from 'functions/ticket';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import AppContext from 'context/Context';


const AgentFeedbackPanel = ({ data, textColor }) => {
  if (!data || data.length === 0) {
    return (
      <Col sm="12 text-center mt-2">
        <p className='text-muted'>No feedback added</p>
      </Col>
    );
  }

  return (
    data.map((d, index) => (
      <div className='mt-2 p-0 bg-light' key={index}>
        <Card.Body>
          <Col md="auto bg-light d-flex justify-content-between align-items-center">
            <div>
              <label className="p-0 m-0" style={{ color: textColor }}>Agent </label>
              <p className="fs--1 pt-0 pl-3" style={{ color: textColor }}>
                {d.displayName}
              </p>
            </div>
            <div>
              {d.isEdited ? (
                <label className="p-0 m-0" style={{ color: textColor }}>
                  Created <span style={{ fontStyle: 'italic', color: textColor }}>(Edited)</span>
                </label>
              ) : (
                <label className="p-0 m-0" style={{ color: textColor }}>Created </label>
              )}
              <p className="fs--1 pt-0 pl-3" style={{ color: textColor }}>
                {moment(d.assignedDate).format('DD MMM, yyyy hh:mm A')}
              </p>
            </div>
          </Col>
          <Row className="gx-2 gy-3">
            <Col sm="6">
              <Form.Group
                as={Row}
                className="mb-2"
                controlId={`formPlaintextPriority-${index}`}
              >
                <Form.Label sm="12" style={{ color: textColor }}>Impact</Form.Label>
                <Col sm="12">
                  <RangeProgressBar value={d.impact} />
                </Col>
              </Form.Group>
            </Col>
            <Col sm="6">
              <Form.Group
                as={Row}
                className="mb-2"
                controlId={`formPlaintextDifficulty-${index}`}
              >
                <Form.Label sm="12" style={{ color: textColor }}>Difficulty</Form.Label>
                <Col sm="12">
                  <RangeProgressBar value={d.difficulty} />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <span style={{ color: textColor }}>{d.remarks}</span>
          </Row>
        </Card.Body>
      </div>
    ))
  );
};



const AssignedAgentsPanel = ({ data, textColor }) => {
  return (
    data &&
    data.map((d, index) => (

      <div key={index}>
        <Row className="">
          <Col md="auto" className="">
            <h6 className="mb-1" style={{ color: textColor }}>Assigned to</h6>
            <p className="fs--1" style={{ color: textColor }}>{d.displayName}</p>
          </Col>

          <Col md="auto" className="">
            <h6 className="mb-1" style={{ color: textColor }}>Date</h6>
            <p className="fs--1" style={{ color: textColor }}>
              {moment(d.assignedDate).format('DD MMM, yyyy hh:mm A')}
            </p>
          </Col>
        </Row>
      </div>

    ))
  );

};

const PropertiesFilteringForm = ({ ticketMasterId, setUserIdHandler }) => {
  const { config } = React.useContext(AppContext);
  const isDark = config?.isDark;
  const textColor = isDark ? '#fff' : '#212529';

  const userDataRaw = localStorage.getItem('userData');
  const _userData = userDataRaw ? JSON.parse(userDataRaw) : {};

  const [drpAgents, setDrpAgents] = useState(null);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isAgentDrpLoading, setIsAgentDrpLoading] = useState(false);

  const [difficulty, setDifficulty] = useState([0]);
  const [impact, setImpact] = useState([0]);
  const [remarks, setRemarks] = useState('');

  const [agentUpdates, setAgentUpdates] = useState([]);
  const [agentFeedbacks, setAgentFeedbacks] = useState([]);
  const [reload, setReload] = useState(false);
  const [reloadAgFeedBk, setReloadAgFeedBk] = useState(false);

  const { roleId } = _userData;

  const setDificultyHandler = (value) => {
    setDifficulty(value);
  }

  const setImpactHandler = (value) => {
    setImpact(value);
  }


  const [ticketMaster, setTicketMaster] = useState(
    {
      ticketNumber: null,
      contactTypeId: null,
      subject: null,
      priorityId: null,
      ticketStatusId: null,
      dueDate: null,
      created: null,
      userId: null,
      updatedDateTime: null,
      userLogId: null,
      assetsMasterId: null,
      assetCategoryId: null,
      uMT: null,
      gmt_Offset: null,
      client: null,
      ticketChargingTypeName: null,
      agent: null,
      priorityName: null,
      categoryName: null,
      assetsName: null,
      assetNumber: null,
      time_elapsed: null
    }
  );


  useEffect(() => {
    loadDrpAgent();
  }, []);

  useEffect(() => {
    loadTicketMasterHeader();
  }, []);

  useEffect(() => {
    loadAgentUpdates();
  }, [reload]);

  useEffect(() => {
    loadAgentFeedbacks();
  }, [reloadAgFeedBk]);



  const loadAgentUpdates = () => {
    const token = localStorage.getItem('token');
    getUpdatesByTicket(ticketMasterId, token).then(data => {
      const agentUpdates = [];
      data && data.map(d => {
        agentUpdates.push({ displayName: d.ContactPerson, assignedDate: d.AssignedDate })
      });

      setAgentUpdates(agentUpdates);

    }).catch(err => {
      console.log('error', err);
    })
  }

  const loadAgentFeedbacks = () => {
    const token = localStorage.getItem('token');

    getAgentFeedbacks(ticketMasterId, token).then(data => {
      console.log('loadAgentFeedbacks:', data)
      const objArray = [];
      data && data.map(d => {
        objArray.push({
          impact: d.Impact, difficulty: d.Difficulty, remarks: d.Remarks, assignedDate: d.CreatedDate_UTC,
          displayName: d.DisplayName, isEdited: d.IsEdited
        })
      });

      setAgentFeedbacks(objArray);
      //setReloadAgFeedBk(reloadAgFeedBk=>!reloadAgFeedBk);
    }).catch(err => {
      console.log('error', err);
    })
  }

  const loadTicketMasterHeader = async () => {

    const token = localStorage.getItem('token');
    const obj = await getTicketMasterCon(ticketMasterId, token);
    console.log('loadTicketMasterHeader obj:', obj);

    if (!obj) {
      console.error('Failed to load ticket master header');
      return;
    }

    setUserIdHandler(obj.UserID);

    setTicketMaster({
      ticketNumber: obj.TicketNumber,
      contactTypeId: obj.ContactTypeId,
      subject: obj.Subject,
      priorityId: obj.PriorityId,
      ticketStatusId: obj.TicketStatusId,
      dueDate: obj.DueDate ? moment(obj.DueDate).format('DD MMM, yyyy hh:mm A') : '--',
      userId: obj.UserID,
      userLogId: obj.UserLogID,
      assetsMasterId: obj.AssetsMasterId,
      assetCategoryId: obj.AssetCategoryId,
      createdDate: moment(obj.CreatedDate_UTC).format('DD MMM, yyyy hh:mm A'),
      gmt_Offset: obj.GMT_Offset,
      client: obj.Client,
      ticketChargingTypeName: obj.TicketChargingTypeName,
      agent: obj.Agent,
      priorityName: obj.PriorityName,
      categoryName: obj.CategoryName,
      assetsName: obj.AssetsName,
      assetNumber: obj.AssetNumber,
      time_elapsed: timeElapsed(obj.CreatedDate_UTC),
      contactType: obj.ContactType,
      companyName: obj.companyName,

    });

    setSelectedAgent(obj.UserID);

    //setDifficulty([obj.Difficulty]);
    //setImpact([obj.Impact]);



  }


  const loadDrpAgent = async () => {
    try {
      setIsAgentDrpLoading(true);
      const res = await getDrpAgents();
      const data = res.data;
      const options = [{ value: '', text: '-select-' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setDrpAgents(options);
      setIsAgentDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const agentFeedbackhandler = async () => {
    try {

      if (!impact && !remarks) {
        toastMessageBox("Exception", "Please ensure you've set the difficulty, impact.", "warning");
        return;
      }

      const token = localStorage.getItem('token');
      const res = await agentFeedbackInertUpdate(ticketMasterId, difficulty, impact, remarks, token);
      setReloadAgFeedBk(reloadAgFeedBk => !reloadAgFeedBk);
      // console.log('agentFeedbackInertUpdate res:', res.data.output.outputMessage);
      if (res.data.error) {
        toastMessageBox("Exception", res.data.error, "danger");
        return;
      }
      const data = res.data.output;

      if (data.responseStatus === "failed") {
        toastMessageBox("Successful", data.outputMessage, "success");
        return;
      }
      toastMessageBox("Successful", data.outputMessage, "success");
      setModalShow(false)
      console.log('ticketAssignHandler', res);

    } catch (err) {
      console.log('Error', err);
    }

  }

  const [modalShow, setModalShow] = React.useState(false);



  const ticketAssignHandler = async () => {
    try {

      if (!selectedAgent) {
        toastMessageBox("Exception", "Select an agent to assign.", "warning");
        return;
      }
      console.log('selectedAgent', selectedAgent);
      const token = localStorage.getItem('token');
      const res = await ticketAssign({ ticketMasterId: ticketMasterId, userId: selectedAgent }, token);
      setReload(reload => !reload);
      const data = res.output;
      if (data.responseStatus === "failed") {
        toastMessageBox("Successful", data.outputMessage, "success");
        return;
      }
      toastMessageBox("Successful", data.outputMessage, "success");
      console.log('ticketAssignHandler', res);

    } catch (err) {
      console.log('Error', err);
    }

  }

  const { subject, contactTypeId, ticketNumber, priorityId, ticketStatusId, dueDate,
    created, userId, updatedDateTime, userLogId, assetsMasterId, assetCategoryId,
    createdDate, gmt_Offset, client, ticketChargingTypeName, agent, priorityName, categoryName,
    assetsName, assetNumber, time_elapsed, Difficulty, Impact, companyName, informedBy, contactType } = ticketMaster;




  return (
    <>
      <CustomModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        heading="Set Feedback"
      >
        <div className="text-center">
          <Row className="gx-2 gy-3">
            <Col sm="12">
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPriority"
              >
                <Form.Label sm="12" style={{ marginBottom: '0px' }}>
                  Impact
                </Form.Label>
                <Col sm="12">
                  <RangeSlider
                    setValues={setImpactHandler}
                    values={impact}
                    step={1}
                    min={0}
                    max={10}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>

          <Row className="gx-2 gy-3">
            <Col sm="12">
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPriority"
              >
                <Form.Label sm="12" style={{ marginBottom: '0px' }}>
                  Difficulty
                </Form.Label>
                <Col sm="12">
                  <RangeSlider
                    setValues={setDificultyHandler}
                    values={difficulty}
                    step={1}
                    min={0}
                    max={10}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>

          <div className="mb-2  text-start">
            <Form.Label className="mb-1 mt-2 fs--1">Remarks</Form.Label>
            <textarea
              className="form-control"
              rows="4"
              placeholder="Add remarks here..."
              value={remarks}
              onChange={e => setRemarks(e.target.value)}
            />
          </div>

          <Button
            varient="primary"
            className="w-100"
            onClick={agentFeedbackhandler}
          >
            Save
          </Button>
        </div>
      </CustomModal>
      <Card className='mb-2'>
        <Card.Header className="bg-light" style={{ color: textColor, background: isDark ? '#23272b' : undefined }}>
          <h6 className="mb-0">Properties</h6>
        </Card.Header>
        <Card.Body style={{ color: textColor, background: isDark ? '#23272b' : undefined }}>
          <Form>
            <Row>
              {/* All Cols below will inherit textColor */}
              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Ticket #</h6>
                <p className="fs--1" style={{ color: textColor }}>{ticketNumber}</p>
              </Col>

              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Created</h6>
                <p className="fs--1" style={{ color: textColor }}>{createdDate}</p>
              </Col>

              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Time Elapsed</h6>
                <p className="fs--1" style={{ color: textColor }}>{time_elapsed}</p>
              </Col>

              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Priority</h6>
                <p className="fs--1" style={{ color: textColor }}>{priorityName}</p>
              </Col>

              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Category</h6>
                <p className="fs--1" style={{ color: textColor }}>{categoryName}</p>
              </Col>

              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Assest</h6>
                <p className="fs--1" style={{ color: textColor }}>{assetsName}</p>
              </Col>

              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Affected Company</h6>
                <p className="fs--1" style={{ color: textColor }}>{companyName}</p>
              </Col>

              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Due date</h6>
                <p className="fs--1" style={{ color: textColor }}>{dueDate}</p>
              </Col>

              <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                <h6 className="mb-1" style={{ color: textColor }}>Contact type</h6>
                <p className="fs--1" style={{ color: textColor }}>{contactType}</p>
              </Col>

              {informedBy && (
                <Col md="auto" className="mb-2 mb-md-0 mb-xl-2">
                  <h6 className="mb-1" style={{ color: textColor }}>Informed/Managed by</h6>
                  <p className="fs--1" style={{ color: textColor }}>{informedBy}</p>
                </Col>
              )}
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {roleId !== 2 && <Card className='mb-2'>
        <Card.Header className="bg-light d-flex justify-content-between align-items-center">
          <h6 className="mb-0">Agent Feedback</h6>
          <Button
            variant="primary"
            className="align-self-start"
            onClick={() => {
              setModalShow(true);
            }}
            size='sm'
          >
            Add Feedback
          </Button>
        </Card.Header>

        <AgentFeedbackPanel data={agentFeedbacks} textColor={textColor} />

      </Card>}

      {roleId !== 2 && (
        <>
          <Card className='mb-2'>
            <Card.Header className="bg-light">
              <h6 className="mb-0">Assign to Agent</h6>
            </Card.Header>
            <Card.Body>
              <Row className="gx-2 gy-3 mb-0">
                <Col sm="12">
                  <div className="mb-0">
                    <Form.Label className="fs--1" style={{ color: textColor }}>
                      Agent
                    </Form.Label>
                    {isAgentDrpLoading ? (
                      <ItemsLoading1
                        animation="border"
                        size="sm"
                        message="Loading..."
                      />
                    ) : (
                      <SelectOption
                        size="sm"
                        options={drpAgents}
                        handleChange={e => {
                          setSelectedAgent(
                            e.target.value === '' ? null : e.target.value
                          );
                        }}
                        selectedValue={selectedAgent}
                        style={{ color: textColor, background: isDark ? '#23272b' : undefined }}
                      />
                    )}
                  </div>

                </Col>

                <Col sm="12">
                  <Button
                    varient="primary"
                    className="w-100"
                    onClick={ticketAssignHandler}
                  >
                    Assign
                  </Button>
                </Col>

                <AssignedAgentsPanel data={agentUpdates} textColor={textColor} />
              </Row>

            </Card.Body>
          </Card>
        </>
      )}
    </>
  );
};

export default PropertiesFilteringForm;
